import { useStatsigClient } from "@statsig/react-bindings";

import { BackButton as LegacyBackButton } from "@/components/Funnel/BackButton";
import { featureFlagNames } from "@/services/experiments/constants";

export function BackButton({ className }: { className?: string }) {
  const { getExperiment } = useStatsigClient();

  const abcTest = getExperiment(
    featureFlagNames.funnel_test_questions_buttons_feedback,
  );

  const isButtonsTestOn =
    abcTest.get("groupSymbol") === "new_questions_and_buttons";

  if (isButtonsTestOn) {
    return null;
  }

  return (
    <div className={className}>
      <LegacyBackButton />
    </div>
  );
}
